import React, { ReactNode } from 'react';
import { ContextPagamentoAutomatico } from '../interfaces/automatico';

interface Props {
    children: ReactNode
}

let dadosPagamentoAutomatico: ContextPagamentoAutomatico = {
    hasData: false,
    dados: {
        consentId: "",
        status: "",
        apiVersion: "",
        startDateTime: "",
        statusUpdateDateTime: "",
        creationDateTime: "",
        expirationDateTime: "",
        amount: "",
        initiatorBy: "",
        frequency: "",
        firstPaymentDate: "",
        horaLimite: "",
        creditor: {
            name: "",
            document: ""
        },
        schedule: {
            startDate: "",
            endDate: "",
            quantity: 0,
            paymentDescription: "",
            paymentType: "",
            contractId: "",
            maximumVariableAmount: ""
        },
        firstPayment: {
            date: "",
            amount: "",
            remittanceInformation: ""
        },
        isRetryAccepted: false
    },
    payload: {
        autenticacaoEletronica: "",
        biometriaFacial: "",
        hashDispositivo: "",
        hashTransacao: "",
        teclas: [],
        tokenSMS: "",
        unitoken: ""
    },
    iniciadora: {
        urlRedirecionamento: "",
        urlLogoIniciadora: "",
        pendente: false
    }
};

export const AutomaticoRequest = React.createContext(dadosPagamentoAutomatico);

export const AutomaticoProvider = ({ children }: Props) => {

    return (
        <AutomaticoRequest.Provider value={dadosPagamentoAutomatico}>
            {children}
        </AutomaticoRequest.Provider>
    );
}